
import React from "react";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  markerIcon?: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  markerIcon,
  className
}) => (
  <div className={`text-center mb-8 sm:mb-16 ${className ?? ""}`}>
    {markerIcon && (
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-md border border-white/30 text-primary rounded-full mb-6 shadow-lg">
        {markerIcon}
        <span className="text-sm font-medium">Why Choose Us</span>
      </div>
    )}
    <h2 className="text-2xl sm:text-4xl font-bold mb-3 sm:mb-6 bg-gradient-to-r from-foreground via-primary to-foreground bg-clip-text text-transparent">
      {title}
    </h2>
    {subtitle && (
      <p className="text-mobile-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeader;
